import { render, staticRenderFns } from "./CheckoutPaymentPixQRCode.vue?vue&type=template&id=a02aa01c&"
import script from "./CheckoutPaymentPixQRCode.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentPixQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VChip,VDivider,VProgressCircular,VTextarea})
